import Storage from '../../utils/StorageManager';

// Function to collect a feature based cookie value from a common cookie key to check it's active/inactive status
export const getCncCookie = cookie => {
  const cncFeatures = Storage.getCookie('cncFeatures');
  if (cookie && cncFeatures) {
    return cncFeatures.split('|').includes(cookie);
  }
  return false;
};
